import styled from "@emotion/styled";
import { InputAdornment, InputBaseProps, TextField } from "@mui/material";
import colors from "theme/colors";

const Asterisk = styled.span<{ $marginBottom?: number; $color: string }>`
  color: ${(p) => p.$color};
  margin-bottom: ${(p) => (p.$marginBottom ? `${p.$marginBottom}px` : "0px")};
  width: 4px;
`

const StyledTextField = styled(TextField)`
  .MuiInputBase-root {
    height: 56px;
  }
  .MuiFormHelperText-root {
    padding-top: 4px;
    font-size: 14px;
  }
  input {
    font: 18px;
    ::placeholder {
      font-size: 18px;
    }
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    input {
      font: 12px;
      ::placeholder {
        font-size: 16px;
      }
    }
    .MuiInputBase-root {
      height: 46px;
    }
    .MuiFormHelperText-root {
      font-size: 12px;
      line-height: 1;
    }
  }

  ${(props) => props.theme.breakpoints.up("lg")} {
    .MuiInputBase-root {
      height: 69px;
    }
    .MuiFormHelperText-root {
      font-size: 14px;
    }
  }
`

type FormInputProps = {
  field: object
  error?: string | undefined
  placeholder: string
  type: string
  required?: boolean
  inputProps?: InputBaseProps
  fullWidth?: boolean
}

function FormInput({
  field,
  error,
  placeholder,
  type = "text",
  required = false,
  inputProps,
  fullWidth = false,
}: FormInputProps) {
  return (
    <StyledTextField
      {...field}
      placeholder={placeholder}
      helperText={error}
      variant="standard"
      error={error ? true : false}
      fullWidth={fullWidth}
      type={type}
      InputProps={{
        ...inputProps,
        startAdornment: required && (
          <InputAdornment position="start">
            <Asterisk
              $marginBottom={28}
              $color={error ? colors.darkRed : colors.blue}
            >
              *
            </Asterisk>
          </InputAdornment>
        ),
      }}
    />
  )
}

export default FormInput
